// extracted by mini-css-extract-plugin
export default {"badgesContainer":"badgesContainer-qifWh8Ax","badgeImage":"badgeImage-oAKAP5o1"};